import { useContext } from "react";
import { Box, styled } from "@mui/material";
import Button from "@common/components/Button";
import { useTranslation } from "react-i18next";
import { NotificationContext } from "@common/components/Notification";

type AlertActionButtonProps = {
  error?: string;
  showDetails: (value: boolean) => void;
};

const AlertLink = styled(Button)({
  paddingBottom: "1rem",
  padding: 0,
  paddingRight: "0.3rem",
  background: "none",
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&:active": {
    boxShadow: "none",
  },
});

const AlertActionButton = ({ error, showDetails }: AlertActionButtonProps) => {
  const { t } = useTranslation();
  const { dispatchNotification } = useContext(NotificationContext);

  const handleClick = async () => {
    dispatchNotification({ type: "pop" });
    try {
      if (error !== undefined) await navigator.clipboard.writeText(error);
      dispatchNotification({
        title: t("Success"),
        message: t("Message has been successfully copied to the clipboard."),
        severity: "success",
      });
    } catch {
      dispatchNotification({
        title: t("Error"),
        message: t(
          "An error occured while copying this message to your clipboard."
        ),
        severity: "error",
      });
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: "0.5rem",
        pl: "1rem",
        gap: "1rem",
      }}
    >
      <AlertLink
        variant="text"
        onClick={() => showDetails(true)}
        data-testid="show-details-button"
      >
        Show Details
      </AlertLink>
      <Button
        variant="outlined"
        onClick={handleClick}
        data-testid="copy-error-button"
      >
        Copy Error
      </Button>
    </Box>
  );
};

export default AlertActionButton;
